import * as z from "zod/v4";

const MerchantOnboardingPhaseSchema_ = z.object({
  label: z.string(),
  status: z.enum(["pending", "active", "done"]),
});

export const getAeoOnboardingProgress = {
  name: "getAeoOnboardingProgress" as const,
  input: z.object({}),
  output: z.object({
    status: z.enum([
      "not_started",
      "setting_up",
      "in_progress",
      "completed",
      "delayed",
      "failed",
    ]),
    progress: z.object({
      completedCount: z.number(),
      percentage: z.number(),
      totalCount: z.number(),
    }),
    currentPhase: z.string().nullable(),
    phases: z.array(MerchantOnboardingPhaseSchema_),
    hasData: z.boolean(),
  }),
};
